export const DISCOUNT_CONFIG = {
  // Set to true to enable NCC discount messaging, false for default messaging.
  showNCCMessaging: true,
  stores: {
    COM: "20",
    FR: "20",
    DE: "20",
    ES: "20",
    IT: "20",
    SE: "20",
    DK: "20",
    NL: "20",
    ROE: "20",
    US: "25",
    AU: "25"
  },
  countryOverrides: {
    IE: "20",
    CA: "25",
    MX: "25",
    SG: "25",
    HK: "25",
    MY: "25",
    TW: "25",
    CN: "25",
    ID: "25",
    KR: "25",
    SA: "25",
    KW: "25",
    QA: "25",
    EG: "25",
    TN: "25",
    OM: "25",
    MA: "25",
    JO: "25",
    BH: "25",
    DZ: "25",
    LB: "25",
    IQ: "25",
    PS: "25",
    AE: "25"
  }
};

export const getNCCDiscountValue = (storeCode, countryCode) => {
  if (!DISCOUNT_CONFIG.showNCCMessaging) {
    return { showNCCMessaging: false };
  }

  const discount =
    DISCOUNT_CONFIG.countryOverrides[countryCode] ||
    DISCOUNT_CONFIG.stores[storeCode];

  return discount
    ? { discount, showNCCMessaging: true }
    : { showNCCMessaging: false };
};
